import { render, staticRenderFns } from "./statisMain.vue?vue&type=template&id=0768dd79&scoped=true"
import script from "./statisMain.vue?vue&type=script&lang=js"
export * from "./statisMain.vue?vue&type=script&lang=js"
import style0 from "./statisMain.vue?vue&type=style&index=0&id=0768dd79&prod&lang=less"
import style1 from "./statisMain.vue?vue&type=style&index=1&id=0768dd79&prod&lang=scss&scoped=true"
import style2 from "./statisMain.vue?vue&type=style&index=2&id=0768dd79&prod&lang=scss"
import style3 from "./statisMain.vue?vue&type=style&index=3&id=0768dd79&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0768dd79",
  null
  
)

export default component.exports